import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const submitDemoRequest = (data) => api.post("/demo-requests", data).then(r => r.data);
export const submitContact = (data) => axios.post("https://dev.api.saaluvar.com/api/contact", data).then(r => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then(r => r.data);
